export const driverCommentsConstants = {
  SECTION_TITLE: 'DRIVER COMMENTS',
  GRID_NAME: 'CustomerDriverCommentsGrid',
  LABEL: {
    DRIVER: 'Driver',
    DRIVER_NUMBER: 'Driver#',
    COMMENTS: 'Notes',
    TIMESTAMP: 'Timestamp',
    COMMENT_COUNT: 'Notes'
  },
  MESSAGE: {
    FETCH_DRIVER_COMMENTS_FAILURE: 'Failed to fetch driver comments'
  }
};

export type DriverComment = {
  rowId: string;
  driverName: string;
  driverNumber: string;
  customerCode: string;
  notes: string;
  createdDateTime?: string;
};
